module.exports = __webpack_public_path__ + "img/杭州师范大学.d3646b96.png";